export default __webpack_public_path__ + "static/media/sprite_icon32v12.03a6c35f.png";